import { useSSRSelector } from '@/redux/ssrStore';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const CategoryNameComp = ({ classes = '', ...props }) => {
  const router = useRouter();
  const [activeCategoryName, setActiveCategoryName] = useState(null);

  const {
    catalogData: { categories, productTags },
  } = useSSRSelector((state) => ({
    catalogData: state.catalogReducer,
  }));

  useEffect(() => {
    if (categories.length > 0 || productTags.length > 0) {
      const allCategories = [...(productTags || []), ...(categories || [])];
      const catId = props?.config?.category_id || router?.query?.cid;
      if (catId) {
        const activeCatIndex = allCategories.findIndex((el) => el.id === Number(catId));
        setActiveCategoryName(allCategories[activeCatIndex]?.name || 'Available Items');
      }
    }
  }, [categories, productTags, router?.query?.cid]);

  return <div className={`category-name ${classes || ''}`}>{activeCategoryName}</div>;
};
